import * as React from 'react';
import { IconProps } from './icon-props';

const BackArrow = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m12 19-7-7 7-7M19 12H5"
    />
  </svg>
);
export default BackArrow;
